import { ClipLoader } from 'react-spinners';

import styles from './styles.module.scss';

export const Spinner = () => (
  <div className={styles.wrapper}>
    <ClipLoader color="#2d6a4f" size={40} />
    <p className={styles.text}>Завантаження меню...</p>
  </div>
);
